module.exports = __webpack_public_path__ + "static/media/pending-shape.ba4d991c.png";